import React from 'react'

//import styles from './Label.module.css'

const MissingPersonLabel = ({
  ai: {
    attributes: { Subject },
  },
}) => (
  <div>
    <div>{Subject || '[BLANK]'}</div>
  </div>
)
export default MissingPersonLabel
